export default "__VITE_ASSET__758d47fb__"